import { useCallback } from 'react';
import axios from 'axios';

/* API */
const globalUrlBackend = `${process.env.REACT_APP_BACKEND_BASE_URL}`;
const globalUrlCreateBackend = `${globalUrlBackend}/api/booking/create`;
const globalUrlUpdateBackend = `${globalUrlBackend}/api/booking/update`;
const globalUrlConfirmBackend = `${globalUrlBackend}/api/booking/confirm`;
const globalUrlCancelBackend = `${globalUrlBackend}/api/booking/cancel`;
const globalCodeBackend = `${process.env.REACT_APP_BACKEND_FUNC_CODE}`;

const useFetchBookings = () => {

  const createBooking = useCallback(async (email, name, startTime, endTime, booking, calculatedRate, language) => {
    try {
        const options = { 
            method: 'POST', 
            url: globalUrlCreateBackend,
            params: {code: globalCodeBackend}, 
            headers: {'content-type': 'application/json'}, 
            data: { 
            Email: email, 
            Name: name, 
            ResourceId: booking.ResourceId, 
            Type: 0, 
            StartTime: startTime, 
            EndTime: endTime, 
            StartDate: booking.StartDate,
            EndDate: booking.EndDate, 
            AmountPaid: calculatedRate,
            Language: language
            } 
        };

        const { data } = await axios.request(options);
        return data;
      } catch (error) {
        console.error(error);
        throw error;
      } 
  }, []);

  const confirmBooking = useCallback(async (booking, sumUpData, voucherId = null) => {
    try {
        const options = { 
          method: 'POST', 
          url: globalUrlConfirmBackend,
          params: { code: globalCodeBackend },
          headers: { 'content-type': 'application/json' }, 
          data: { 
            bookingId: `${booking.bookingCode}_${booking.email}`, 
            checkoutId: booking.checkoutId, 
            paymentResult: sumUpData.paymentResult,
            ...(voucherId && { voucherId })
          } 
        };
    
        const { data } = await axios.request(options);
        return data;
      } catch (error) {
        console.error(error);
        throw error;
      }
  }, []);

  const cancelBooking = useCallback(async (bookingId) => {
    try {
        const options = { 
        method: 'POST', 
        url: globalUrlCancelBackend,
        params: { code: globalCodeBackend }, 
        headers: { 'content-type': 'application/json' }, 
        data: { bookingId }
        };
    
        const { data } = await axios.request(options);
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
  }, []);

  const manageCabinBooking = useCallback(async (resourceId, email, bookingCode, startDate, endDate, startTime, endTime, action) => {
    try {
        const options = { 
          method: 'POST', 
          url: globalUrlUpdateBackend,
          params: { code: globalCodeBackend },
          headers: { 'content-type': 'application/json' }, 
          data: { 
            BookingId: `${bookingCode}_${email}`, 
            ResourceId: resourceId,
            StartTime: startTime,
            EndTime: endTime,
            StartDate: startDate,
            EndDate: endDate,
            Action: action // "1" confirm - "2" cancel
          } 
        };
    
        const { data } = await axios.request(options);
        return data;
      } catch (error) {
        console.error(error);
        throw error;
      }
  }, []);

  return { createBooking, confirmBooking, cancelBooking, manageCabinBooking };
};

export default useFetchBookings;
